import React, { useState } from "react";
import PropTypes from "prop-types";
import "./SuggestionList.css";
import IconSparkle from "../../../assets/icon_sparkle.svg";

const SuggestionList = ({
  showSuggestions,
  title,
  suggestedBrands,
  suggestedCategories,
  brandsLoading,
  categoriesLoading,
  onSelectBrand,
  onSelectCategory,
}) => {
  const [selectedBrandName, setSelectedBrandName] = useState(null);
  const [selectedCategoryKey, setSelectedCategoryKey] = useState(null);

  // 카테고리 고유 키 생성 함수
  const getCategoryKey = (category) => {
    return `${category.gender}-${category.category}-${category.subcategory}`;
  };

  if (
    !showSuggestions ||
    (title && title.length < 2) ||
    (!brandsLoading &&
      !categoriesLoading &&
      (!suggestedBrands || suggestedBrands.length === 0) &&
      (!suggestedCategories || suggestedCategories.length === 0))
  ) {
    return null;
  }

  return (
    <div className="SuggestionList-container">
      {((suggestedBrands && suggestedBrands.length > 0) ||
        (suggestedCategories && suggestedCategories.length > 0)) && (
        <div className="SuggestionList-title">
          <img src={IconSparkle} alt="spackle" />
          <span>이런거 찾으시나요?</span>
        </div>
      )}
      {suggestedBrands && suggestedBrands.length > 0 && (
        <div className="SuggestionList-section">
          <div className="label">브랜드 추천</div>
          <div className="common-grid">
            {suggestedBrands.map((brand, index) => {
              const isSelected = selectedBrandName === brand.name;
              return (
                <label
                  key={`brand-${index}`}
                  className="common-option"
                  onClick={() => {
                    if (isSelected) return;
                    setSelectedBrandName(brand.name);
                    onSelectBrand(brand, index);
                  }}
                >
                  <input type="radio" checked={isSelected} readOnly />
                  <span
                    className={`common-label ${isSelected ? "selected" : ""}`}
                  >
                    {brand.name}
                  </span>
                </label>
              );
            })}
          </div>
        </div>
      )}

      {suggestedCategories && suggestedCategories.length > 0 && (
        <div className="SuggestionList-section">
          <div className="label">카테고리 추천</div>
          <div className="common-grid">
            {suggestedCategories.map((category, index) => {
              const categoryKey = getCategoryKey(category);
              const isSelected = selectedCategoryKey === categoryKey;
              return (
                <label
                  key={`category-${index}`}
                  className="common-option"
                  onClick={() => {
                    if (isSelected) return;
                    setSelectedCategoryKey(categoryKey);
                    onSelectCategory(category, index);
                  }}
                >
                  <input type="radio" checked={isSelected} readOnly />
                  <span
                    className={`common-label ${isSelected ? "selected" : ""}`}
                  >
                    {category.gender === "men"
                      ? "남성"
                      : category.gender === "women"
                        ? "여성"
                        : "공용"}{" "}
                    &gt; {category.category} &gt; {category.subcategory}
                  </span>
                </label>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

SuggestionList.propTypes = {
  showSuggestions: PropTypes.bool,
  title: PropTypes.string,
  suggestedBrands: PropTypes.array,
  suggestedCategories: PropTypes.array,
  brandsLoading: PropTypes.bool,
  categoriesLoading: PropTypes.bool,
  onSelectBrand: PropTypes.func,
  onSelectCategory: PropTypes.func,
};

export default SuggestionList;
